module.exports = __webpack_public_path__ + "img/cart-icon.1eeac2d5.svg";